export enum RegistrationStatusEnum {
    ERROR_FOUND = 'error found',
    VERIFICATION_NEEDED = 'verification needed',
    SUCCESS = 'success',
}
